export const CONFIGURATOR_TYPE = 'GOAL_VOTING';

export const MAX_GOALS_IN_VOTING = 4;

export const DEFAULT_SLOT_COLORS = ['#007FFF', '#FDC019', '#62FF00', '#EE4141'];
